<script setup lang="ts">
import { PrimaryButton } from '@/components/Buttons'
import { StackLayout } from '@/components/Layouts'
import FullScreenLoader from '@/components/LoadingSpinner/FullScreenLoader.vue'
import { BaseDialog } from '@/components/Modals/Dialog'
import type { DeviceModel } from '@/types/models/DeviceModel'
import { ref } from 'vue'
import store from '../../../../../store'
import { EDeviceActions } from '../../../../../store/deviceStore/DeviceStoreTypes'
import { EStoreModules } from '../../../../../store/storeType'
import TypographyItem from '../../../../Typography/TypographyItem.vue'

type Props = {
    device: Partial<DeviceModel>
}
const props = defineProps<Props>()
type Emits = {
    (e: 'refresh'): void
}
const emit = defineEmits<Emits>()

const open = ref(false)
const isLoading = ref(false)

const handleConfirmButton = () =>
    store
        .dispatch(`${EStoreModules.DEVICE}/${EDeviceActions.REINITIALIZE_DEVICE_FLAG}`, {
            deviceId: props.device.device_id ?? props.device.id
        })
        .then(() => {
            emit('refresh')
            open.value = false
        })
</script>

<template>
    <FullScreenLoader :isLoading="isLoading" />
    <PrimaryButton
        :label="$t('device.reinitializeFlag.buttonTitle')"
        @click="open = true"
        v-bind="$attrs" />
    <BaseDialog
        :title="$t('device.reinitializeFlag.dialogTitle')"
        :open="open"
        @close="open = false"
        @confirm="handleConfirmButton"
        class="dialog-with-dropdown">
        <template #content>
            <StackLayout class="full-width">
                <TypographyItem :label="$t('device.reinitializeFlag.dialogContent')" />
            </StackLayout>
        </template>
    </BaseDialog>
</template>
